<div class="row" *ngIf="pspes.modifiedPointStoreProduct != null">
    <div class="col-xl-12 fake-card mx-auto pt-3 px-5">
        <div class="row">
            <div class="col-sm-12 col-md-7">
                <div class="row">
                    <div class="col-12">
                        <h2 cvLocalizedText langSection="MarketPlace_Management" langKey="Product_Details" class="color-theUpsideDown font-size-20 lato-regular my-4">Product Details</h2>
                    </div>
                </div>
                <div class="row">
                    <div class="col-3"><span cvLocalizedText langSection="MarketPlace_Management"
                            langKey="Title">Title</span>:</div>
                    <div class="col-9 txtOverflow color-whaleTail"><span
                            title="{{getProductInfo('title')}}">{{getProductInfo('title')}}</span></div>
                </div>
                <div class="row">
                    <div class="col-3"><span cvLocalizedText langSection="MarketPlace_Management"
                            langKey="Description">Description</span>:</div>
                    <div class="col-9 txtOverflow color-whaleTail"><span
                            title="{{getProductInfo('description')}}">{{getProductInfo('description')}}</span></div>
                </div>
                <div class="row">
                    <div class="col-3"><span cvLocalizedText langSection="MarketPlace_Management"
                            langKey="Category">Category</span>:</div>
                    <div class="col-9 txtOverflow color-whaleTail"><span
                            title="{{getProductInfo('category')}}">{{getProductInfo('category')}}</span></div>
                </div>
                <div class="row">
                    <div class="col-3"><span cvLocalizedText langSection="MarketPlace_Management"
                            langKey="Sub_Category">Sub-Category</span>:</div>
                    <div class="col-9 txtOverflow color-whaleTail"><span
                            title="{{getProductInfo('subCategory')}}">{{getProductInfo('subCategory')}}</span></div>
                </div>
                <div class="row">
                    <div class="col-3"><span cvLocalizedText langSection="MarketPlace_Management"
                            langKey="Quantity_Available">Total Quantity</span>:</div>
                    <div class="col-9 txtOverflow color-whaleTail"><span
                            title="{{getProductInfo('quantity')}}">{{getProductInfo('quantity')}}</span></div>
                </div>
                <div class="row">
                    <div class="col-3"><span cvLocalizedText langSection="MarketPlace_Management"
                            langKey="Available_Starting">Available Starting</span>:</div>
                    <div class="col-9 txtOverflow color-whaleTail"><span
                            title="{{getProductInfo('productStart')}}">{{getProductInfo('productStart')}}</span></div>
                </div>
                <div class="row">
                    <div class="col-3"><span cvLocalizedText langSection="MarketPlace_Management"
                            langKey="Available_Until">Available Until </span>:</div>
                    <div class="col-9 txtOverflow color-whaleTail">
                        <span title="{{getProductInfo('productEnd')}}">
                            <span [hidden]="!(getProductInfo('productEnd') == 'Ongoing')" cvLocalizedText
                                langSection="MarketPlace_Management" langKey="Ongoing">Ongoing</span>
                            <span [hidden]="!(getProductInfo('productEnd') != 'Ongoing')">
                                {{getProductInfo('productEnd')}}</span>
                        </span>
                    </div>
                </div>
                <div class="row">
                    <div cvLocalizedText langSection="MarketPlace_Management" langKey="Variations" class="col-3"><span>Variations</span>:</div>
                    <div class="col-9 txtOverflow color-whaleTail"
                        *ngIf="pspes.modifiedPointStoreProduct.HasProductVariations"><span>{{getQty()}}
                            {{pspes.modifiedPointStoreProduct.VariationName}}</span></div>
                    <div cvLocalizedText langSection="Common" langKey="None" class="col-9 txtOverflow color-whaleTail"
                        *ngIf="!pspes.modifiedPointStoreProduct.HasProductVariations"><span>None</span></div>
                </div>
                <div class="row"
                    [hidden]="!(!pspes.modifiedPointStoreProduct.HasProductVariations || (pspes.modifiedPointStoreProduct.HasProductVariations && !pspes.modifiedPointStoreProduct.HasVariationPrices))">
                    <div class="col-3"><span cvLocalizedText langSection="MarketPlace_Management"
                            langKey="Price">Price</span>:</div>
                    <div class="col-9 txtOverflow color-whaleTail">
                        <span title="Coins: {{getProductInfo('price')}} {{getDollarFromCoinConversion()}}">
                            <span>{{getProductInfo('price') | cvNumberLocalize}}</span>
                            <span>{{getDollarFromCoinConversion()}}</span>
                        </span>
                    </div>
                </div>
                <div *ngIf="pspes.modifiedPointStoreProduct.HasProductVariations">
                    <div class="row">
                        <div cvLocalizedText langSection="MarketPlace_Management" langKey="Variation_Details" class="col-3 font-size-14 lato-bold"><span>Variation Details</span></div>
                        <div cvLocalizedText langSection="MarketPlace_Management" langKey="Name" class="col-3 font-size-14 lato-bold color-whaleTail"><span>Name</span></div>
                        <div cvLocalizedText langSection="MarketPlace_Management" langKey="Price" class="col-3 font-size-14 lato-bold color-whaleTail"
                            *ngIf="pspes.modifiedPointStoreProduct.HasVariationPrices"><span>Price</span></div>
                        <div cvLocalizedText langSection="MarketPlace_Management" langKey="Quantity" class="col-3 font-size-14 lato-bold color-whaleTail"><span>Quantity</span></div>
                    </div>
                    <div class="row" *ngFor="let variation of pspes.modifiedPointStoreProduct.VariationsData">
                        <div class="col-3 font-size-14 lato-bold"><span></span></div>
                        <div class="col-3 font-size-14 color-whaleTail"><span>{{variation.VariationName}}</span></div>
                        <div class="col-3 font-size-14 color-whaleTail"
                            *ngIf="pspes.modifiedPointStoreProduct.HasVariationPrices"><span>{{variation.VariationPrice
                                | cvNumberLocalize}}</span></div>
                        <div class="col-3 font-size-14 color-whaleTail"><span>{{variation.VariationQuantity |
                                cvNumberLocalize}}</span></div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 pt-3 pb-2">
                        <hr />
                    </div>
                </div>
                <!-- Display Settings -->
                <div class="row">
                    <div class="col-3 font-size-14 lato-bold"><span cvLocalizedText langSection="MarketPlace_Management"
                            langKey="Display_Settings">Display Settings</span></div>
                    <div class="col-3 font-size-14 lato-bold color-whaleTail"><span cvLocalizedText
                            langSection="MarketPlace_Management" langKey="Start_Date_Summary">Start Date</span></div>
                    <div class="col-3 font-size-14 lato-bold color-whaleTail"><span cvLocalizedText
                            langSection="MarketPlace_Management" langKey="End_Date_Summary">End Date</span></div>
                </div>
                <div class="row">
                    <div class="col-3">
                        <span cvLocalizedText langSection="MarketPlace_Management" langKey="On_Carousel">On
                            Carousel</span>:
                        <span *ngIf="pspes.modifiedPointStoreProduct.IsCarouselChecked" cvLocalizedText
                            langSection="MarketPlace_Management" langKey="Yes">Yes</span>
                        <span *ngIf="!pspes.modifiedPointStoreProduct.IsCarouselChecked" cvLocalizedText
                            langSection="MarketPlace_Management" langKey="No">No</span>
                    </div>
                    <div class="col-3 color-whaleTail"><span>{{getDisplaySettingValue('carousel', true)}}</span></div>
                    <div class="col-3 color-whaleTail"><span>{{getDisplaySettingValue('carousel', false)}}</span></div>
                </div>
                <div class="row">
                    <div class="col-3">
                        <span cvLocalizedText langSection="MarketPlace_Management"
                            langKey="Is_Featured_Summary">Featured</span>:
                        <span *ngIf="pspes.modifiedPointStoreProduct.IsFeaturedChecked" cvLocalizedText
                            langSection="MarketPlace_Management" langKey="Yes">Yes</span>
                        <span *ngIf="!pspes.modifiedPointStoreProduct.IsFeaturedChecked" cvLocalizedText
                            langSection="MarketPlace_Management" langKey="No">No</span>
                    </div>
                    <div class="col-3 color-whaleTail"><span>{{getDisplaySettingValue('featured', true)}}</span></div>
                    <div class="col-3 color-whaleTail"><span>{{getDisplaySettingValue('featured', false)}}</span></div>
                </div>
                <div class="row">
                    <div class="col-3">
                        <span cvLocalizedText langSection="MarketPlace_Management" langKey="On_Sale">On Sale</span>:
                        <span
                            *ngIf="pspes.modifiedPointStoreProduct.IsOnSaleChecked">{{pspes.modifiedPointStoreProduct.Sale}}%
                            <span id="Span2" cvLocalizedText langSection="MarketPlace_Management" langKey="OFF_Summary">
                                off</span></span>
                        <span class="ml-1" *ngIf="!pspes.modifiedPointStoreProduct.IsOnSaleChecked" cvLocalizedText
                            langSection="MarketPlace_Management" langKey="No">No</span>
                    </div>
                    <div class="col-3 color-whaleTail"><span>{{getDisplaySettingValue('sale', true)}}</span></div>
                    <div class="col-3 color-whaleTail"><span>{{getDisplaySettingValue('sale', false)}}</span></div>
                </div>
                <!-- END Display Settings -->
                <div class="row">
                    <div class="col-12 pt-3 pb-2">
                        <hr />
                    </div>
                </div>
                <!-- Assignments -->
                <div class="row">
                    <div class="col-12  font-size-14 lato-bold"><span cvLocalizedText
                            langSection="MarketPlace_Management" langKey="Assignments">Assignments</span></div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div [hidden]="!(pspes.modifiedPointStoreProduct.PointStoreProductAllAssignments.length > 0)"
                            *ngFor="let assignment of pspes.modifiedPointStoreProduct.PointStoreProductAssignments">
                            <span title="{{assignment.GroupSubNames}} {{assignment.GroupTypeName}}">
                                <span [hidden]="!(assignment.Name == 'All Groups Assigned')" cvLocalizedText
                                    langSection="MarketPlace_Management" langKey="All_Assigned_Groups">All Groups
                                    Assigned</span>
                                <span [hidden]="!(assignment.Name != 'All Groups Assigned')">{{assignment.Name}}</span>
                            </span>
                        </div>
                    </div>
                    <div class="col-12">
                        <div cvLocalizedText langSection="Objectives" langKey="Employee_Groups" class="typeHeader lato-bold font-size-14" style="margin-top:8px;">Employee Group(s)</div>
                        <div [hidden]="!(pspes.modifiedPointStoreProduct.PointStoreProductAssignments == null || (pspes.modifiedPointStoreProduct.PointStoreProductAllAssignments.emp.length <= 0 && !pspes.modifiedPointStoreProduct.PointStoreProductAllAssignments.empAssignAll))">
                            <span cvLocalizedText langSection="MarketPlace_Management_Messages" langKey="No_Groups_Assigned">No groups assigned</span>
                        </div>
                        <div class="assignAtLabel"
                            [hidden]="!(pspes.modifiedPointStoreProduct.PointStoreProductAllAssignments.empAssignAll)"
                            cvLocalizedText langSection="Objectives" langKey="All_Groups">All Groups</div>
                        <div *ngFor="let obj of pspes.modifiedPointStoreProduct.PointStoreProductAllAssignments.emp">
                            <div class="FlexRowNoWrap itemContainer"
                                *ngIf="!pspes.modifiedPointStoreProduct.PointStoreProductAllAssignments.empAssignAll">
                                <div class="objectiveItem txtOverflow">- {{obj.GroupName}}</div>
                                <!-- <select class="selectItem" ng-model="obj.applyAt" *ngIf="$ctrl.showall == false && obj.GroupLevel > 1">
                                    <option ng-repeat="item in $ctrl.empgrouptypes" *ngIf="item.GroupLevel <= obj.GroupLevel" value="{{item.GroupLevel}}">{{item.GroupTypeName}}</option>
                                </select> -->
                            </div>
                        </div>
                        <div>
                            <div class="typeHeader lato-bold font-size-14 mt-2"><span cvLocalizedText langSection="Objectives" langKey="Attributes">Attribute(s) </span><span
                                cvLocalizedText langSection="Objectives" langKey="Optional" class="color-valyrianSteel">(Optional)</span></div>
                            <div class="assignAtLabel"
                                [hidden]="!(pspes.modifiedPointStoreProduct.PointStoreProductAllAssignments.attr.length == 0)"
                                cvLocalizedText langSection="Common" langKey="None">None</div>
                            <div
                                *ngFor="let obj of pspes.modifiedPointStoreProduct.PointStoreProductAllAssignments.attr">
                                <div class="FlexRowNoWrap itemContainer" *ngIf="obj.AttributeValueID != null">
                                    <div class="objectiveItem txtOverflow">- {{obj.AttributeValueName}}</div>
                                    <div class="removeHolder FlexRowNoWrap">
                                        <!-- <div class="removeIcon FlexAlignVertical" (click)="ctrlOAB.onRemove($index, obj)"></div> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- END  Assignments -->
            </div>
            <div class="col-sm-12 col-md-3">
                <div class="row">
                    <div class="col-12">
                        <h2 cvLocalizedText langSection="MarketPlace_Management" langKey="Product_Preview" class="color-theUpsideDown font-size-20 lato-regular my-4">Product Preview</h2>
                    </div>
                </div>
                <div class="bg-greekToMe d-flex" style="width:430px;height:430px;">
                    <div class="col-8 align-self-center mx-auto">
                        <span>
                            <div class="card border-0 marketplace-card">
                                <div class="pictures-label" [hidden]="!(ProductHasMultipleImages())">
                                    <span >+{{getMultipleImagesCount()}} <span cvLocalizedText langSection="MarketPlace" langKey="Pictures">Pictures</span></span>
                                </div>
                                <div class="card-img-container text-center">
                                    <div
                                        [ngClass]="pspes.modifiedPointStoreProduct.PointStoreProductAllAssignments.attr.length > 0  ? 'locked-item-overlay' : ''">
                                    </div>
                                    <img cvLocalizedText langSection="MarketPlace_Management"
                                        langKey="Image_Not_Available" [alt]="getImageNotAvailableTitle()"
                                        [title]="checkImageNotAvailable() ? getImageNotAvailableTitle() : ''"
                                        [src]="getPreviewSource()" style="width:200px;" />
                                    <svg *ngIf="pspes.modifiedPointStoreProduct.PointStoreProductAllAssignments.attr.length > 0"
                                        class="icon-32 fill-white marketplace-locked-item left-icon">
                                        <use xlink:href=""
                                            [attr.href]="pspes.modifiedPointStoreProduct.PointStoreProductAllAssignments.attr.length > 0 ? '../../../App_Themes/clearview-default/icons/utility/lock.svg#lock' : '../../../App_Themes/clearview-default/icons/utility/unlock.svg#unlock'">
                                        </use>
                                    </svg>
                                </div>
                                <div class="card-body">
                                    <h5 class="card-title" style="margin-bottom: 8px; height:auto;">
                                        {{pspes.modifiedPointStoreProduct.Title}}</h5>
                                    <div class="row">
                                        <div class="col-12 product-prices" style="white-space: nowrap; height: 30px;">
                                            <label
                                                *ngIf="pspes.modifiedPointStoreProduct.HasProductVariations && pspes.modifiedPointStoreProduct.HasVariationPrices"
                                                style="color:#6a7480; margin-right:8px;" cvLocalizedText langSection="MarketPlace_Management" langKey="Starting_From">Starting from: </label>
                                            <svg class="marketplace-coins-icon">
                                                <use
                                                    href="../../../App_Themes/clearview-default/icons/utility/coins.svg#coins">
                                                </use>
                                            </svg>
                                            <div *ngIf="pspes.modifiedPointStoreProduct.HasProductVariations && pspes.modifiedPointStoreProduct.HasVariationPrices"
                                                style="display:inline-block;">
                                                <span class="regular-price"
                                                    [ngClass]="saleVariationFlag == true ? 'onSale' : ''">{{getVariationPrice()
                                                    | cvNumberLocalize}}</span>
                                                <span class="sale-price ml-1"
                                                    [hidden]="!(saleVariationFlag == true)">{{checkSaleVariationPrice()
                                                    | cvNumberLocalize}} </span>
                                            </div>
                                            <div *ngIf="!pspes.modifiedPointStoreProduct.HasProductVariations || (pspes.modifiedPointStoreProduct.HasProductVariations && !pspes.modifiedPointStoreProduct.HasVariationPrices)"
                                                style="display:inline-block;">
                                                <span class="regular-price"
                                                    [ngClass]="isSaleActive() ? 'onSale' : ''">{{pspes.modifiedPointStoreProduct.Price
                                                    | cvNumberLocalize:true}}</span>
                                                <span class="sale-price ml-1"
                                                    [hidden]="!(isSaleActive())">{{getAgentPrice()
                                                    | cvNumberLocalize}} </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-10">
                                            <label [hidden]="!(pspes.modifiedPointStoreProduct.HasProductVariations)"
                                                class="font-size-12 color-valyrianSteel variationNameLabel"><span cvLocalizedText langSection="MarketPlace_Management" langKey="Variation_Available">Available in</span>
                                                {{getQty()}} <span
                                                    title="{{pspes.modifiedPointStoreProduct.VariationName}}">{{pspes.modifiedPointStoreProduct.VariationName}}</span></label>
                                        </div>
                                        <div class="col-2 d-flex justify-content-end align-items-center">
                                            <div class="badge badge-sale" *ngIf="isSaleActive()">
                                                <span cvLocalizedText langSection="MarketPlace_Management"
                                                    langKey="Sale">Sale</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div class="form-group row">
            <div class="col-12 d-flex justify-content-end">
                <button type="button" class="btn btn-text mr-2" (click)="cancel()">
                    <span cvLocalizedText langSection="MarketPlace_Management" langKey="Cancel">Cancel</span>
                </button>
                <button type="button" class="btn btn-primary" (click)="save()" [disabled]="pspes.isSavingProduct">
                    <span class="primaryActionButtonText" cvLocalizedText langSection="MarketPlace_Management"
                        langKey="Save">Save</span>
                </button>
            </div>
        </div>
        <!-- <pre>Modified: {{pspes.modifiedPointStoreProduct | json}}</pre> -->
    </div>
</div>
